export default "/images/vendor/quill/icons/italic.svg?ff0ddc3f7d3244531d0a87389f6e151a";